
import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import NumberFormat from 'react-number-format';

import FusionCharts from 'fusioncharts/core';
import Line from 'fusioncharts/viz/line';

import CylinderPromo from "./dashboardv2/CylinderPromo";
import RedeemedPromos from './dashboardv2/RedeemedPromos';
import DaysChart from './dashboardv2/DaysChart';

FusionCharts.addDep(Line);

class Reportsv2 extends React.Component
{
    constructor(props) {
        super(props);

        this.createReport = this.createReport.bind(this);
        this.renderButtons = this.renderButtons.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);
        this.setDetails = this.setDetails.bind(this);

        this.state = {
            url: "",
            buttons: [],
            pages: [],
            currentPage: [],
            indexPage: 0,
            months: [],
            years: [],
            redimidos: 0,
            promos: []
        };
    }

    componentWillMount()
    {
        let self = this;
    }

    componentDidMount()
    {
        if (year < 2023) {
            swal({
                title: "¡Oh no!",
                text: "No se han obtenido resultados.",
                icon: "warning",
            });
        }

        let self = this;
        let months = [
            "enero",
            "febrero",
            "marzo",
            "abril",
            "mayo",
            "junio",
            "julio",
            "agosto",
            "septiembre",
            "octubre",
            "noviembre",
            "diciembre"
        ];

        let date = new Date();
        let diffYears = date.getFullYear() - 2023;
        let years = [];

        for (let i = 0; i <= diffYears; i++)
            years.push(2023 + i);

        self.setState({
            months: months,
            years: years
        });

        let month_url = "";

        switch (month) {
            case "enero": month_url = "01"; break;
            case "febrero": month_url = "02"; break;
            case "marzo": month_url = "03"; break;
            case "abril": month_url = "04"; break;
            case "mayo": month_url = "05"; break;
            case "junio": month_url = "06"; break;
            case "julio": month_url = "07"; break;
            case "agosto": month_url = "08"; break;
            case "septiembre": month_url = "09"; break;
            case "octubre": month_url = "10"; break;
            case "noviembre": month_url = "11"; break;
            case "diciembre": month_url = "12"; break;
        }

        if (year >= 2023) {
            axios.get('/api/_reports/' + month_url + '/' + year)
            .then(response => {

                let redimidos = response.data.count;

                if (redimidos !== 0) {
                    let redimidos = response.data.redimidos;
                    let promos = response.data.promos;

                    self.setState({
                        redimidos: redimidos,
                        promos: promos,
                    });

                    console.log(promos);
                }
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "No se han obtenido resultados.",
                    icon: "warning",
                });
            });

            $('#botonBarraLateral').click();
        }
    }

    createReport()
    {
        let self = this;

        swal({
            title: 'Un momento...',
            text: 'Estamos procesando tu solicitud.',
            buttons: false,
            showCancelButton: false,
            showConfirmButton: false,
            closeOnClickOutside: false,
        });

        let month_url = "";

        switch (month) {
            case "enero": month_url = "01"; break;
            case "febrero": month_url = "02"; break;
            case "marzo": month_url = "03"; break;
            case "abril": month_url = "04"; break;
            case "mayo": month_url = "05"; break;
            case "junio": month_url = "06"; break;
            case "julio": month_url = "07"; break;
            case "agosto": month_url = "08"; break;
            case "septiembre": month_url = "09"; break;
            case "octubre": month_url = "10"; break;
            case "noviembre": month_url = "11"; break;
            case "diciembre": month_url = "12"; break;
        }

        if (year >= 2023) {
            axios.get('/api/_reports/' + month_url + '/' + year + '/users')
            .then(response => {

                let url = response.data;

                self.setState({
                    url: url
                });

                swal({
                    title: "¡Bien!",
                    text: "El reporte se ha generado correctamente.",
                    icon: "success",
                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "No se han obtenido resultados.",
                    icon: "warning",
                });
            });
        }
    }

    handleMonthChange()
    {
        let month_selected = $('#month_select_input :selected').val();
        window.location.href = "/_reports/" + month_selected + "/" + year;
    }

    handleYearChange()
    {
        let month_selected = $('#month_select_input :selected').val();
        let year_selected = $('#year_select_input :selected').val();

        window.location.href = "/_reports/" + month_selected + "/" + year_selected;
    }


    setPage(index)
    {
        let self = this;
        let page = self.state.pages[index];

        self.setState({
            currentPage: page,
            indexPage: index
        });
    }

    renderButtons(item)
    {
        let self = this;
        let style = {
            marginLeft: "10px",
            marginRight: "10px",
            marginBottom: "10px",
            width: "40px"
        };

        let clase = self.state.indexPage === item-1 ? 'btn-info': 'btn-success';

        return(
            <button key={item} className={"btn " + clase} style={style}
                    onClick={this.setPage.bind(this, item-1)}>
                {item}
            </button>
        );
    }

    renderItemsCurrentPage(item)
    {
        let key = Math.random();
        return(
            <tr key={key}>
                <td>{item.display_assign_date}</td>
                <td>{item.tdc}</td>
                <td>{item.promo}</td>
            </tr>
        );
    }

    renderOptions(item)
    {
        return <option key={item} value={item}>{item}</option>
    }

    renderPromos(item)
    {
        return (
            <div className="col-md-3 col-sm-6 col-lg-3 col-xs-12" key={item.promo}>
                <div className="card-box widget-box-1 bg-white">
                    <h4 className="text-dark"
                        style={{ fontSize: "large", fontWeight: "bold" }}>
                        {item.promo}
                    </h4>
                    <CylinderPromo promo={item}/>
                </div>
            </div>
        );
    }

    setDetails()
    {
        let self = this;
        let month_url = "";

        switch (month) {
            case "enero": month_url = "01"; break;
            case "febrero": month_url = "02"; break;
            case "marzo": month_url = "03"; break;
            case "abril": month_url = "04"; break;
            case "mayo": month_url = "05"; break;
            case "junio": month_url = "06"; break;
            case "julio": month_url = "07"; break;
            case "agosto": month_url = "08"; break;
            case "septiembre": month_url = "09"; break;
            case "octubre": month_url = "10"; break;
            case "noviembre": month_url = "11"; break;
            case "diciembre": month_url = "12"; break;
        }

        if (year >= 2023) {
            axios.get('/api/_reports/' + month_url + '/' + year + '/details/1')
            .then(response => {
                self.setState({
                    currentPage: response.data.list
                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "No se han obtenido resultados.",
                    icon: "warning",
                });
            });

            $('#detailsModal').modal('show');
        }
    }

    render()
    {
        let percent = (this.state.redimidos*100 / 2572);

        return (
            <div>
                <div className="modal fade bs-example-modal-lg" tabIndex="-1" role="dialog"
                        aria-labelledby="myLargeModalLabel" aria-hidden="true" id="detailsModal">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                <h4 className="modal-title" id="myLargeModalLabel">Vista previa del detalle de redenciones</h4>
                            </div>
                            <div className="modal-body">
                                <small>Se muestran los últimos 15 usuarios que han reclamado una promoción.</small>
                                {
                                    this.state.url.length === 0 &&
                                    <button className="btn btn-success pull-right" onClick={this.createReport}>
                                        <i className="fa fa-line-chart"></i> Generar reporte
                                    </button>
                                }
                                {
                                    this.state.url.length !== 0 &&
                                    <a href={this.state.url}>
                                        <button className="btn btn-info pull-right">
                                            <i className="fa fa-download"></i> Descargar reporte
                                        </button>
                                    </a>
                                }
                                <hr/>
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Fecha Asignación</th>
                                        <th>Tarjeta Sí Vale</th>
                                        <th>Promoción</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.currentPage.map(this.renderItemsCurrentPage)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card-box widget-box-1 bg-white">
                            <div className="row">
                                <div className="col-md-2">
                                    <label>Selecciona un mes:</label>
                                    <select className="form-control" id="month_select_input"
                                            onChange={this.handleMonthChange}
                                            value={month}>
                                        {this.state.months.map(this.renderOptions.bind(this))}
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label>Selecciona un año:</label>
                                    <select className="form-control" id="year_select_input"
                                            onChange={this.handleYearChange}
                                            value={year}>
                                        {this.state.years.map(this.renderOptions.bind(this))}
                                    </select>
                                </div>
                                <div className="col-md-2 col-md-offset-3 visible-lg">
                                    <img src={"/img/up_si_vale.png"} className="img-responsive"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3">
                        <div className="card-box widget-box-1 bg-white">
                            <h4 className="text-dark"
                                style={{ fontSize: "large", fontWeight: "bold" }}>
                                Códigos totales
                            </h4>
                            <div className="col-md-4">
                                <h1 className="text-primary text-center hidden-sm hidden-xs hidden-lg"
                                    style={{ fontSize: "large", fontWeight: "bold" }}>
                                    <i className="fa fa-ticket fa-2x"></i>
                                </h1>
                                <h1 className="text-primary text-center hidden-sm hidden-xs hidden-md"
                                    style={{ fontSize: "large", fontWeight: "bold" }}>
                                    <i className="fa fa-ticket fa-3x"></i>
                                </h1>
                            </div>
                            <div className="col-md-8">
                                <div className="row">
                                    <h1 className="text-primary text-center"
                                        style={{ fontSize: "-webkit-xxx-large", fontWeight: "bold" }}>
                                        <NumberFormat value={2572} displayType={'text'} thousandSeparator={true}/>
                                    </h1>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                        </div>

                        <div className="card-box widget-box-1 bg-white">
                            <h4 className="text-dark"
                                style={{ fontSize: "large", fontWeight: "bold" }}>
                                Códigos entregados
                                <button className="btn btn-info pull-right" onClick={this.setDetails}>
                                    <i className="fa fa-search" style={{fontSize: "large" }}></i>
                                </button>
                            </h4>
                            <br />
                            <div className="col-md-4">
                                <h1 className="text-warning text-center hidden-sm hidden-xs hidden-lg"
                                    style={{ fontSize: "large", fontWeight: "bold" }}>
                                    <i className="fa fa-users fa-2x"></i>
                                </h1>
                                <h1 className="text-warning text-center hidden-sm hidden-xs hidden-md"
                                    style={{ fontSize: "large", fontWeight: "bold" }}>
                                    <i className="fa fa-users fa-3x"></i>
                                </h1>
                            </div>
                            <div className="col-md-8">
                                <div className="row">
                                    <h1 className="text-warning text-center"
                                        style={{ fontSize: "-webkit-xxx-large", fontWeight: "bold" }}>
                                        <NumberFormat value={this.state.redimidos} displayType={'text'} thousandSeparator={true}/>
                                    </h1>
                                    <h1 className="text-warning text-center"
                                        style={{ fontSize: "xx-large", fontWeight: "bold" }}>
                                        {percent.toFixed(2)} %
                                    </h1>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                        </div>

                        <div className="card-box widget-box-1 bg-white">
                            <h4 className="text-dark"
                                style={{ fontSize: "large", fontWeight: "bold" }}>
                                Códigos disponibles
                            </h4>
                            <div className="col-md-4">
                                <h1 className="text-success text-center hidden-sm hidden-xs hidden-lg"
                                    style={{ fontSize: "large", fontWeight: "bold" }}>
                                    <i className="fa fa-check-circle-o fa-2x"></i>
                                </h1>
                                <h1 className="text-success text-center hidden-sm hidden-xs hidden-md"
                                    style={{ fontSize: "large", fontWeight: "bold" }}>
                                    <i className="fa fa-check-circle-o fa-3x"></i>
                                </h1>
                            </div>
                            <div className="col-md-8">
                                <div className="row">
                                    <h1 className="text-success text-center"
                                        style={{ fontSize: "-webkit-xxx-large", fontWeight: "bold" }}>
                                        <NumberFormat value={2572 - this.state.redimidos} displayType={'text'} thousandSeparator={true}/>
                                    </h1>
                                    <h1 className="text-success text-center"
                                        style={{ fontSize: "xx-large", fontWeight: "bold" }}>
                                        {(100-percent).toFixed(2)} %
                                    </h1>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>

                    <div className="modal fade bs-example-modal-lg" tabIndex="-1" role="dialog"
                         aria-labelledby="myLargeModalLabel" aria-hidden="true" id="detailsModal">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                    <h4 className="modal-title" id="myLargeModalLabel">Vista previa del detalle de redenciones</h4>
                                </div>
                                <div className="modal-body">
                                    <small>Se muestran los últimos 15 usuarios que han reclamado una promoción.</small>
                                    {
                                        this.state.url.length === 0 &&
                                        <button className="btn btn-success pull-right" onClick={this.createReport}>
                                            <i className="fa fa-line-chart"></i> Generar reporte
                                        </button>
                                    }
                                    {
                                        this.state.url.length !== 0 &&
                                        <a href={this.state.url}>
                                            <button className="btn btn-info pull-right">
                                                <i className="fa fa-download"></i> Descargar reporte
                                            </button>
                                        </a>
                                    }
                                    <hr/>
                                    <table className="table table-striped">
                                        <thead>
                                        <tr>
                                            <th>Promoción</th>
                                            <th>Fecha de asignación</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.currentPage.map(this.renderItemsCurrentPage)}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-9">
                        <DaysChart days={this.state.days}/>
                    </div>

                </div>

                <div className="row">
                    <div className="container"
                         style={{ paddingLeft: "0px", paddingRight: "0px"}}>
                        <div className="col-md-3" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                            <div className="card-box widget-box-1 bg-white" style={{ height: "757px" }}>
                                <h4 className="text-dark"
                                    style={{ fontSize: "large", fontWeight: "bold" }}>
                                    Códigos asignados por promoción *</h4>
                                <RedeemedPromos />
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        <div className="col-md-9" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                            {this.state.promos.map(this.renderPromos.bind(this))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Reportsv2;

if (document.getElementById('reports-component-v2')) {
    ReactDOM.render(<Reportsv2 />, document.getElementById('reports-component-v2'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/Reportsv2.jsx